import React, { useState, useEffect } from "react";
import {
  collection,
  doc,
  getDoc,
  getDocs,
  query,
  where,
  updateDoc,
  writeBatch,
  serverTimestamp,
  deleteDoc,
} from "firebase/firestore";
import { firestore, GeoFirestore } from "../../firebase";
import { useNavigate, useParams } from "react-router-dom";
import { getAuth } from "firebase/auth";
import firebase from "firebase/compat/app";
import Autocomplete from "react-google-autocomplete";
import ngeohash from "ngeohash";
import "firebase/compat/firestore";
import Modal from "react-modal";
import EditEvent from "./editEvent";
import SportsAPIComponent from "./editLocationComponents/components/sportsAPIComponent";
import GetEventsFromXml from "./editLocationComponents/components/getEventsFromXml";
import UniversalEventScraper from "./editLocationComponents/components/universalScraperAPI";
import { generateUniqueSlug } from "../../utils/slug";

const db = firestore;

const Events = ({ currentBusinessID, userInformation }) => {
  const [newEventName, setNewEventName] = useState("");
  const [newEvent, setNewEvent] = useState(false);
  const [newTMEvents, setNewTMEvents] = useState(false);
  const [sportsEventsAPI, setSportsEventsAPI] = useState(false);
  const [xmlApi, setXMLApi] = useState(false);
  const [universalAPI, setUniversalAPI] = useState(false);
  const [APIEvents, setAPIEvents] = useState(false);
  const [price, setPrice] = useState(0);
  const [eventTime, setEventTime] = useState(null);
  const [missingFields, setMissingFields] = useState({
    name: false,
    location: false,
    startDate: false,
    endDate: false,
  });
  const [startDate, setStartDate] = useState(0);
  const [endDate, setEndDate] = useState(0);
  const [eventLocation, setEventLocation] = useState(null);
  const [changingLocation, setchangingLocation] = useState(false);
  const [businessInformation, setBusinessInformation] = useState(null);
  const [freeDays, setFreedays] = useState(0);
  const [eventList, setEventList] = useState([]);
  const [businessLocations, setBusinessLocations] = useState([]);
  const [selectedLongLat, setSelectedLongLat] = useState([]);
  const [ticketMasterLocations, setTicketMasterLocations] = useState([]);
  const [googlePlacesLongLat, setGooglePlacesLongLat] = useState(null);
  const [selectedTMVenue, setSelectedTMVenue] = useState(null);
  const [selectTMVenueEvents, setSelectedTMVenueEvents] = useState([]);
  const [openTMModal, setOpenTMModal] = useState(false);

  const navigate = useNavigate();
  let { edit } = useParams();

  useEffect(() => {
    const effectFunction = async () => {
      const userInfo = doc(db, "businesses", currentBusinessID);
      const userInformation = await getDoc(userInfo);
      const userData = userInformation.data();
      const menus = userData.menus;

      setBusinessInformation(userData);
      setFreedays(userData.freeEventDays ?? 0);

      let activeLocations = [];

      for (const menu of menus) {
        // Assuming each menu has an identifier to get the specific locations collection
        const locationsRef = doc(db, "lokasjoner", menu);
        const querySnapshot = await getDoc(locationsRef);
        activeLocations.push(querySnapshot);

        // if (querySnapshot.data().active === true) {
        //   activeLocations.push(querySnapshot);
        // }
      }
      setBusinessLocations(activeLocations);

      if (userData.events !== undefined && userData.events.length > 0) {
        fetchEvents(userData.events);
      }
    };

    const isValidID =
      currentBusinessID &&
      typeof currentBusinessID === "string" &&
      currentBusinessID.length > 0;

    if (isValidID) {
      effectFunction();
    } else {
      console.log("Invalid business ID. Please check the ID or sign in.");
    }
  }, [currentBusinessID]);

  const fetchEvents = async (listData) => {
    const fetchedData = await Promise.all(
      listData.map(async (value) => {
        const docRef = doc(db, "events", value);
        const docSnapshot = await getDoc(docRef);
        return docSnapshot;
      }),
    );

    setEventList(fetchedData);
  };

  const onAddNewEvent = async () => {
    const userInfo = doc(db, "businesses", currentBusinessID);
    const geocollection = GeoFirestore.collection("events");
    const businessInformation = await getDoc(userInfo);
    const busienssData = businessInformation.data();

    const fields = {
      name: newEventName === "",
      location: eventLocation === null,
      startDate: startDate === 0,
      eventTime: eventTime === null,
    };

    setMissingFields(fields);

    //   // Optional: Do something if there are missing fields, like prevent form submission
    if (
      fields.name ||
      fields.location ||
      fields.startDate ||
      fields.eventTime
    ) {
      console.log("Please fill all the fields.");
      return;
    }

    console.log(eventTime);
    console.log(startDate);

    const dateDateTime = new Date(startDate * 1000); // convert seconds → ms

    dateDateTime.setHours(eventTime.hour);
    dateDateTime.setMinutes(eventTime.minutes);
    dateDateTime.setSeconds(0);
    dateDateTime.setMilliseconds(0);

    console.log(dateDateTime);

    let businessEvents = busienssData.events ? busienssData.events : [];

    const newEventSlug = await generateUniqueSlug(newEventName);
    const newEvent = await geocollection.add({
      locationName: newEventName,
      slug: newEventSlug,
      aboutBusiness: "",
      aboutEvent: "",
      active: false,
      shownOnBusinessPage: false,
      startDate: 0,
      endDate: startDate + 86400, // default to 1 day after start
      eventDate: startDate,
      eventTime: eventTime,
      eventDateTime: dateDateTime,
      eventOrganiser: eventLocation.id,
      eventOrganiserName: eventLocation.data().locationName,
      lang: eventLocation.data().lang ? eventLocation.data().lang : "nb_NO",
      lat: eventLocation.data().lat,
      lng: eventLocation.data().lng,
      paymentPrice: price,
      averagePrice: 0,
      tags: [],
      tagsLang: { en_US: [], nb_NO: [] },
      type: "event",
      coordinates: new firebase.firestore.GeoPoint(
        eventLocation.data().lat,
        eventLocation.data().lng,
      ),
      onlyStudents: userInformation.studentOrganisasjon ? true : false,
      studentOrgInvitedName: userInformation.studentOrganisasjon
        ? userInformation.studentOrganisasjon
        : null,
    });

    businessEvents.push(newEvent.id);

    await updateDoc(userInfo, {
      events: businessEvents,
    });

    navigate("/MyBusiness/events/" + newEvent.id);
  };

  const onAddTMEvents = async (autoFillTMEvents) => {
    const userInfoRef = doc(db, "businesses", currentBusinessID);
    const userInformation = await getDoc(userInfoRef);
    const userData = userInformation.data();

    if (!userData && autoFillTMEvents === true) {
      alert(
        "Du må velge en lokasjon for å kunne hente arrangementer automatisk fra Ticketmaster hver 7 dag.",
      );
      return;
    }

    const geocollection = GeoFirestore.collection("events");

    let businessEvents = Array.isArray(userData?.events)
      ? [...userData.events]
      : [];

    // 1) Preload all existing Ticketmaster events for this venue (single query).
    //    This avoids 1-query-per-event.
    const eventsCol = collection(db, "events");
    const existingSnap = await getDocs(
      query(
        eventsCol,
        where("source", "==", "ticketmaster"),
        where("tmVenueId", "==", selectedTMVenue.id),
        // Optional: if you keep "eventOrganiser", you can also filter by it:
        // where("eventOrganiser", "==", eventLocation?.id ?? null)
      ),
    );

    const existingByTmId = new Map();
    existingSnap.forEach((d) => {
      const data = d.data();
      if (data?.tmEventId)
        existingByTmId.set(data.tmEventId, { ref: d.ref, data });
    });

    // 2) We’ll batch updates for "cancelled" toggles (cheap + atomic)
    const batch = writeBatch(db);

    // 3) Process Ticketmaster events
    for (const event of selectTMVenueEvents) {
      const tmId = event.id;
      const status = TM_STATUS(event); // e.g. "cancelled", "onsale", etc.
      const existing = existingByTmId.get(tmId);

      if (!existing) {
        // CREATE (new event only)
        const eventDate = event.dates.start.dateTime
          ? Math.floor(new Date(event.dates.start.dateTime).getTime() / 1000)
          : null;

        const eventTime = event.dates.start.dateTime
          ? new Date(event.dates.start.dateTime).toLocaleTimeString("nb-NO", {
              hour: "2-digit",
              minute: "2-digit",
            })
          : null;

        const eventDateTime = event.dates.start.dateTime ?? null;

        const eventDateObj = new Date(event.dates.start.dateTime);

        const aboutEvent =
          "Dato: " +
          eventDateObj.toLocaleDateString("nb-NO", {
            day: "2-digit",
            month: "short",
            year: "numeric",
          }) +
          "\n" +
          "Tid: " +
          eventDateObj.toLocaleTimeString("nb-NO", {
            hour: "2-digit",
            minute: "2-digit",
          }) +
          "\nBilletter fås kjøpt her:\n" +
          (event.url ? event.url : "Ikke tilgjengelig");

        const aboutEventEng =
          "Date: " +
          eventDateObj.toLocaleDateString("en-GB", {
            day: "2-digit",
            month: "short",
            year: "numeric",
          }) +
          "\n" +
          "Time: " +
          eventDateObj.toLocaleTimeString("en-GB", {
            hour: "2-digit",
            minute: "2-digit",
          }) +
          "\nTickets can be purchased here:\n" +
          (event.url ? event.url : "Not available");

        const tags = [
          event.classifications?.[0]?.segment?.name,
          event.classifications?.[0]?.genre?.name,
        ].filter(Boolean);

        const mainProfileImage =
          event?._embedded?.attractions?.[0]?.images?.[0]?.url ??
          event?.images?.[0]?.url ??
          null;

        const newDocRef = await geocollection.add({
          // --- your existing fields ---
          locationName: event.name,
          slug: await generateUniqueSlug(event.name),
          aboutBusiness: "",
          aboutEvent,
          aboutEventLang: { en_US: aboutEventEng, nb_NO: aboutEvent },
          active: false,
          shownOnBusinessPage: autoFillTMEvents,
          startDate: 0,
          endDate: eventDate + 86400, // default to 1 day after start if end date is not provided by TM
          eventDate: eventDate,
          eventTime,
          eventDateTime,
          eventOrganiser: eventLocation?.id ?? null,
          eventOrganiserName: eventLocation.data().locationName,
          lat: selectedLongLat.lat,
          lng: selectedLongLat.lng,
          paymentPrice: 0,
          averagePrice: null,
          tags,
          tagsLang: { en_US: tags, nb_NO: tags },
          locationTags: tags,
          locationTagsLang: { en_US: tags, nb_NO: tags },
          mainProfileImage: mainProfileImage,
          type: "event",
          coordinates: new firebase.firestore.GeoPoint(
            selectedLongLat.lat,
            selectedLongLat.lng,
          ),

          // --- new metadata for safe future syncs ---
          source: "ticketmaster",
          tmEventId: tmId,
          tmVenueId: selectedTMVenue.id,
          status: status || "scheduled", // snapshot of TM status
          createdFromTMAt: serverTimestamp(),
        });

        // Keep business->events relation in sync
        businessEvents.push(newDocRef.id);
      } else {
        // EXISTS: DO NOT OVERWRITE user edits.
        // Only update when Ticketmaster says "cancelled"
        if (status === "cancelled" && existing.data.status !== "cancelled") {
          batch.update(existing.ref, {
            status: "cancelled",
            shownOnBusinessPage: false,
            cancelledAt: serverTimestamp(),
          });
        }

        // Ensure the business has this event id linked
        const existingId = existing.ref.id;
        if (!businessEvents.includes(existingId)) {
          businessEvents.push(existingId);
        }
      }
    }

    // 4) Commit any queued "cancelled" updates
    await batch.commit();

    // 5) Save venue autofill metadata and events array on the business
    if (eventLocation) {
      const newAutoFillTMEventIds = Array.isArray(userData?.autoFillTMEventsIds)
        ? [...userData.autoFillTMEventsIds]
        : [];
      const newAutoFillTMEventOrganisers = Array.isArray(
        userData?.autoFillTMEventsOrganisers,
      )
        ? [...userData.autoFillTMEventsOrganisers]
        : [];

      if (autoFillTMEvents) {
        if (!newAutoFillTMEventIds.includes(selectedTMVenue.id)) {
          newAutoFillTMEventIds.push(selectedTMVenue.id);
        }
        if (!newAutoFillTMEventOrganisers.includes(eventLocation.id)) {
          newAutoFillTMEventOrganisers.push(eventLocation.id);
        }
      }

      await updateDoc(userInfoRef, {
        events: businessEvents,
        autoFillTMEventsIds: newAutoFillTMEventIds,
        autoFillTMEventsOrganisers: newAutoFillTMEventOrganisers,
        lastTmSyncAt: serverTimestamp(),
      });
    }

    onGoBack();
  };

  const onGoBack = () => {
    setNewEvent(false);
    setNewTMEvents(false);
    setPrice(0);
    setStartDate(0);
    setEndDate(0);
    setNewEventName("");
    setEventLocation(null);
    setGooglePlacesLongLat(null);
    setSelectedLongLat([]);
    setTicketMasterLocations([]);
    setSelectedTMVenueEvents([]);
    setSelectedTMVenue(null);
    setMissingFields({
      name: false,
      location: false,
      startDate: false,
      eventTime: false,
    });
    window.location.reload();
  };

  const onSetLocation = (event) => {
    setEventLocation(event);
    setchangingLocation(false);
  };

  useEffect(() => {
    if (startDate !== 0 && endDate !== 0) {
      if (endDate > startDate) {
        let newPrice = 0;
        newPrice = endDate - startDate;
        let newPriceInDays = newPrice / (3600 * 24);
        if (freeDays > 0) {
          if (newPriceInDays - freeDays > 0) {
            newPriceInDays = newPriceInDays - freeDays;
          } else {
            newPriceInDays = 0;
          }
        }

        setPrice(newPriceInDays * 25);
        console.log(newPriceInDays);
      } else {
        setPrice(0);
      }
    }
  }, [startDate, endDate]);

  useEffect(() => {
    if (eventLocation !== null) {
      setSelectedLongLat({
        lat: eventLocation.data().lat,
        lng: eventLocation.data().lng,
      });
    } else if (googlePlacesLongLat !== null) {
      setSelectedLongLat({
        lat: googlePlacesLongLat.lat(),
        lng: googlePlacesLongLat.lng(),
      });
    }
  }, [eventLocation, googlePlacesLongLat]);

  useEffect(() => {
    if (selectedLongLat.length !== 0) {
      const fetchTicketMaster = async () => {
        const geohash = ngeohash.encode(
          selectedLongLat.lat,
          selectedLongLat.lng,
        );
        const url = `https://app.ticketmaster.com/discovery/v2/venues?apikey=FSSqSQlJwFA1b7shs5fkG0UiczAGQR3M&locale=*&countryCode=NO&domain=ticketmaster.no&geoPoint=${geohash}`;
        const response = await fetch(url);
        const data = await response.json();
        if (data._embedded && data._embedded.venues) {
          console.log(data._embedded.venues);
          setTicketMasterLocations(data._embedded.venues);
        }
      };
      fetchTicketMaster();
    }
  }, [selectedLongLat]);

  const TM_STATUS = (tmEvent) => tmEvent?.dates?.status?.code ?? "scheduled"; // "cancelled", "postponed", "rescheduled", etc.

  // const onSelectVenue = async (venue) => {
  //   const url = `https://app.ticketmaster.com/discovery/v2/events.json?apikey=FSSqSQlJwFA1b7shs5fkG0UiczAGQR3M&venueId=${venue.id}&locale=*`;
  //   const response = await fetch(url);
  //   const data = await response.json();
  //   if (data._embedded && data._embedded.events) {
  //     console.log(data._embedded.events);
  //     setSelectedTMVenue(venue);
  //     setSelectedTMVenueEvents(data._embedded.events);
  //   }
  // };
  const onSelectVenue = async (venue) => {
    let allEvents = [];
    let page = 0;
    let totalPages = 1;

    while (page < totalPages) {
      const url = `https://app.ticketmaster.com/discovery/v2/events.json?apikey=FSSqSQlJwFA1b7shs5fkG0UiczAGQR3M&venueId=${venue.id}&locale=*&size=200&page=${page}`;

      const response = await fetch(url);
      const data = await response.json();

      if (data._embedded && data._embedded.events) {
        allEvents = [...allEvents, ...data._embedded.events];
      }

      if (data.page) {
        totalPages = data.page.totalPages;
      }

      page++;
    }

    // 🔹 Fetch descriptions for each event
    // const enrichedEvents = await Promise.all(
    //   allEvents.map(async (event) => {
    //     try {
    //       const scrapeRes = await fetch(
    //         "http://localhost:8080/ticketmaster-description",
    //         {
    //           method: "POST",
    //           headers: {
    //             "Content-Type": "application/json",
    //           },
    //           body: JSON.stringify({
    //             url: event.url,
    //           }),
    //         },
    //       );

    //       const scrapeData = await scrapeRes.json();

    //       return {
    //         ...event,
    //         description: scrapeData.description || "",
    //       };
    //     } catch (err) {
    //       console.error("Description fetch failed:", err);

    //       return {
    //         ...event,
    //         description: "",
    //       };
    //     }
    //   }),
    // );

    console.log(allEvents);

    setSelectedTMVenue(venue);
    setSelectedTMVenueEvents(allEvents);
  };

  const onPromotePlussSeven = async (event) => {
    if (userInformation?.admin !== true) {
      return;
    }
    console.log(event.id);
    const docRef = doc(db, "events", event.id);

    const eventInformation = (await getDoc(docRef)).data();
    if (eventInformation.active === false) {
      updateDoc(doc(db, "events", event.id), {
        active: true,
        startDate: eventInformation.endDate - 7 * 24 * 3600, // add 7 days
      });
    } else {
      updateDoc(doc(db, "events", event.id), {
        startDate: eventInformation.startDate - 7 * 24 * 3600, // add 7 days
      });
    }
  };

  const onDeleteAllEvets = async () => {
    if (userInformation?.admin !== true) {
      return;
    }
    console.log(businessInformation.events);
    for (const eventId of businessInformation.events) {
      await deleteDoc(doc(db, "events", eventId));
    }
    await updateDoc(doc(db, "businesses", currentBusinessID), {
      events: [],
    });
    window.location.reload();
  };

  return edit !== undefined ? (
    <EditEvent currentBusinessID={currentBusinessID} />
  ) : changingLocation ? (
    <>
      <div>
        <h1>Hvilken lokasjon gjelder arragementet for?</h1>
        {businessLocations.length > 0 ? (
          businessLocations.map((lokasjonsInformasjon, rowIndex) => {
            return (
              <div
                key={rowIndex}
                className='box'
                style={{ marginBottom: "15px" }}>
                <div className='businessOverView'>
                  <label className='locationNameLabel'>
                    {lokasjonsInformasjon.data()?.locationName}
                  </label>
                  <label>
                    {lokasjonsInformasjon.data()?.adress
                      ? lokasjonsInformasjon.data()?.adress
                      : "-"}
                  </label>
                  <div>
                    <a
                      onClick={() => {
                        onSetLocation(lokasjonsInformasjon);
                      }}
                      className='universalButtonRed'
                      style={{ marginLeft: "5px" }}>
                      Velg
                    </a>
                  </div>
                </div>
              </div>
            );
          })
        ) : (
          <p style={{ textAlign: "center", marginTop: 0 }}>
            Ingen lokasjoner å vise til
          </p>
        )}
      </div>
    </>
  ) : newEvent ? (
    <>
      <div>
        <h1>Opprett ny lokasjon</h1>
        <div
          className='box'
          style={{
            borderTopLeftRadius: 0,
            padding: 25,
            paddingRight: 35,
            marginBottom: "50px",
          }}>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginTop: "20px",
            }}>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                width: "38%",
              }}>
              <label className='editPageLabel'>Navn på arrangementet</label>
              <input
                placeholder='Navn'
                value={newEventName}
                onChange={(x) => {
                  setNewEventName(x.target.value);
                }}
              />
              <label
                style={{
                  display: missingFields.name ? "block" : "none",
                  color: "#f9615b",
                }}>
                Her mangler det noe!
              </label>
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                width: "58%",
              }}>
              <label className='editPageLabel'>
                Hvilken lokasjon gjelder arragementet for?
              </label>
              <input
                placeholder='Lokasjon'
                style={{ cursor: "pointer", fontWeight: "bold" }}
                onClick={() => {
                  setchangingLocation(true);
                }}
                value={
                  eventLocation !== null
                    ? eventLocation.data().adress !== undefined
                      ? eventLocation.data().locationName +
                        " - " +
                        eventLocation.data().adress
                      : eventLocation.data().locationName
                    : ""
                }
              />
              <label
                style={{
                  display: missingFields.location ? "block" : "none",
                  color: "#f9615b",
                }}>
                Her mangler det noe!
              </label>
            </div>
          </div>
          <div
            style={{
              marginTop: "20px",
              display: "flex",
              // justifyContent: "space-between",
            }}>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                width: "30%",
              }}>
              <label className='editPageLabel'>Dato for arrangementet</label>
              <input
                placeholder='-- -- --'
                type='date'
                min={new Date().toISOString().split("T")[0]}
                style={{ paddingRight: "10px" }}
                onChange={(x) => {
                  setStartDate(new Date(x.target.value).getTime() / 1000);
                }}
              />
              <label
                style={{
                  display: missingFields.startDate ? "block" : "none",
                  color: "#f9615b",
                }}>
                Her mangler det noe!
              </label>
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                width: "30%",
                marginLeft: "5%",
              }}>
              <label className='editPageLabel'>
                Start tid for arrangementet
              </label>
              <input
                placeholder='-- -- --'
                type='time'
                style={{ paddingRight: "10px" }}
                onChange={(x) => {
                  const [hrs, mins] = x.target.value.split(":").map(Number);
                  setEventTime(() => ({
                    // Ensure hours and minutes are stored as numbers
                    hour: hrs || 0, // Fallback to 0 if hrs is NaN
                    minutes: mins || 0, // Fallback to 0 if mins is NaN
                  }));
                }}
              />
              <label
                style={{
                  display: missingFields.eventTime ? "block" : "none",
                  color: "#f9615b",
                }}>
                Her mangler det noe!
              </label>
            </div>
          </div>
          {freeDays !== 0 ? (
            <div style={{ marginTop: "15px" }}>
              Du har {freeDays} gratis annonsedager igjen å bruke. Disse vil
              automatisk trekkes fra prisen.
            </div>
          ) : (
            <></>
          )}
          <div>
            <button
              onClick={onAddNewEvent}
              className='universalButtonRed'
              style={{
                width: "150px",
                marginTop: "25px",
                marginRight: "10px",
              }}>
              Gå videre
            </button>
            <button
              style={{
                width: "150px",
                marginTop: "25px",
              }}
              onClick={onGoBack}
              className='universalButton'>
              Avbryt
            </button>
          </div>
        </div>
      </div>
    </>
  ) : APIEvents ? (
    newTMEvents ? (
      <>
        <div>
          <h1>Hent arrangementer fra Ticketmaster</h1>
          <div
            className='box'
            style={{
              borderTopLeftRadius: 0,
              padding: 25,
              paddingRight: 35,
              marginBottom: "50px",
            }}>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginTop: "20px",
              }}>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  width: "38%",
                }}>
                <label className='editPageLabel'>Søk på lokasjon</label>
                <Autocomplete
                  options={{
                    types: ["places"] + ["establishment"] + ["address"],
                  }}
                  placeholder='Søk etter bedriftens lokasjon eller adresse'
                  apiKey={"AIzaSyBzqNdOb1GQUpeP2bFfsed64Yp_hEALAQ4"}
                  onPlaceSelected={(place) => {
                    setGooglePlacesLongLat(place.geometry.location);
                  }}
                />
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  width: "58%",
                }}>
                <label className='editPageLabel'>
                  Eller koble arrangementene til en av dine lokasjoner
                </label>
                <input
                  placeholder='Lokasjon'
                  style={{ cursor: "pointer", fontWeight: "bold" }}
                  onClick={() => {
                    setchangingLocation(true);
                  }}
                  value={
                    eventLocation !== null
                      ? eventLocation.data().adress !== undefined
                        ? eventLocation.data().locationName +
                          " - " +
                          eventLocation.data().adress
                        : eventLocation.data().locationName
                      : ""
                  }
                />
                <label
                  style={{
                    display: missingFields.location ? "block" : "none",
                    color: "#f9615b",
                  }}>
                  Her mangler det noe!
                </label>
              </div>
            </div>

            {ticketMasterLocations.length > 0 ? (
              selectTMVenueEvents.length > 0 ? (
                <>
                  <div className='eventHeader' style={{ marginTop: "30px" }}>
                    Arrangementer funnet i Ticketmaster for lokasjon:{" "}
                    {selectedTMVenue.name}
                  </div>

                  {selectTMVenueEvents.map((x, index) => {
                    return (
                      <div
                        style={{
                          marginBottom: 10,
                          marginRight: 15,
                          maringleft: 15,
                          backgroundColor: "#F6F5F0",
                          borderRadius: 10,
                        }}>
                        <div
                          style={{
                            position: "relative",
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                          }}>
                          <div
                            style={{
                              marginTop: 10,
                              position: "relative",
                              display: "flex",
                              flexDirection: "row",
                              width: "100%",
                            }}>
                            <div
                              style={{
                                borderRadius: 100,
                                width: 100,
                                height: 100,
                                paddingLeft: 2,
                                paddingBottom: 1,
                                justifyContent: "center",
                                alignItems: "center",
                                backgroundColor: "#EDEDED",
                                marginRight: 8,
                                marginLeft: 10,
                              }}>
                              {x._embedded?.attractions?.[0]?.images?.[0]
                                ?.url ? (
                                <img
                                  style={{
                                    borderRadius: 100,
                                    width: 100,
                                    height: 100,
                                    resize: "contain",
                                  }}
                                  src={x._embedded.attractions[0].images[0].url}
                                />
                              ) : (
                                x.images?.[0]?.url && (
                                  <img
                                    style={{
                                      borderRadius: 100,
                                      width: 100,
                                      height: 100,
                                      resize: "contain",
                                    }}
                                    src={x.images[0].url}
                                  />
                                )
                              )}
                            </div>
                            <div style={{ marginRight: 130 }}>
                              <label
                                style={{
                                  color: "black",
                                  fontWeight: "bold",
                                  fontSize: 18,
                                  marginBottom: 2,
                                  fontFamily: "Inter",
                                }}>
                                {x.name}
                              </label>
                              {x.classifications.length > 0 && (
                                <div
                                  style={{
                                    display: "flex",
                                    flexDirection: "row",
                                    flexWrap: "wrap",
                                  }}>
                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "center",
                                      textAlign: "center",
                                      paddingLeft: 10,
                                      paddingRight: 10,
                                      width: "auto",
                                      borderRadius: 10,
                                      marginBottom: 2,
                                      marginRight: 3,
                                      backgroundColor: "#4550E2",
                                      color: "white",
                                      fontSize: 12,
                                    }}>
                                    {x.classifications[0].segment.name}
                                  </div>
                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "center",
                                      textAlign: "center",
                                      paddingLeft: 10,
                                      paddingRight: 10,
                                      width: "auto",
                                      borderRadius: 10,
                                      marginBottom: 2,
                                      marginRight: 3,
                                      backgroundColor: "#4550E2",
                                      color: "white",
                                      fontSize: 12,
                                    }}>
                                    {x.classifications[0].genre.name}
                                  </div>
                                </div>
                              )}
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                  justifyContent: "space-between",
                                  marginTop: 12,
                                  marginBottom: 10,
                                  width: "100%",
                                }}>
                                <div
                                  style={{
                                    display: "flex",
                                    flexDirection: "row",
                                  }}>
                                  <label
                                    style={{
                                      color: "black",
                                      fontSize: 14,
                                    }}>
                                    Dato:{" "}
                                    {new Date(
                                      x.dates.start.dateTime,
                                    ).toLocaleDateString("nb-NO", {
                                      day: "2-digit", // Ensure the day is two digits
                                      month: "2-digit", // Ensure the month is two digits}
                                      year: "numeric", // Full year
                                    })}
                                  </label>
                                </div>
                                <div
                                  style={{
                                    display: "flex",
                                    flexDirection: "row",
                                  }}>
                                  <label
                                    style={{
                                      color: "black",
                                      fontSize: 14,
                                    }}>
                                    Tid:{" "}
                                    {new Date(
                                      x.dates.start.dateTime,
                                    ).toLocaleTimeString("nb-NO", {
                                      hour: "2-digit",
                                      minute: "2-digit",
                                    })}
                                  </label>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </>
              ) : (
                <>
                  <div className='eventHeader' style={{ marginTop: "30px" }}>
                    Lokasjoner funnet i Ticketmaster
                  </div>
                  {ticketMasterLocations.map((x, index) => {
                    return (
                      <div className='eventMain'>
                        <label style={{ fontWeight: "bold" }}>{x.name}</label>
                        <button
                          onClick={() => {
                            onSelectVenue(x);
                          }}
                          className='universalButtonRed'>
                          Velg
                        </button>
                      </div>
                    );
                  })}
                </>
              )
            ) : (
              <> </>
            )}
            <div>
              <button
                onClick={() => {
                  setOpenTMModal(true);
                }}
                className='universalButtonRed'
                style={{
                  width: "150px",
                  marginTop: "25px",
                  marginRight: "10px",
                }}>
                Gå videre
              </button>
              <button
                style={{
                  width: "150px",
                  marginTop: "25px",
                }}
                onClick={onGoBack}
                className='universalButton'>
                Avbryt
              </button>
            </div>
          </div>
        </div>
        <Modal
          isOpen={openTMModal}
          onRequestClose={() => {
            setOpenTMModal(false);
          }}
          className='modalStyle'
          style={{
            content: {
              width: "20%",
              height: "40%",
            },
          }}>
          <div className='editActiveModal'>
            <label className='editPageLabel'>
              Vil du at vi skal hente arrangementer automatisk fra Ticketmaster
              for deg hver 7 dag og publisere disse på din bedriftsprofil?
            </label>
            <div className='editActiveModalButtonContainer'>
              <button
                onClick={() => {
                  onAddTMEvents(true);
                }}
                className='universalButtonRed'
                style={{
                  width: "70%",
                  margin: 0,
                  marginBottom: 10,
                  height: 60,
                }}>
                Ja, hent automatisk fra Ticketmaster hver 7 dag (Anbefalt)
              </button>
              <button
                onClick={() => {
                  onAddTMEvents(false);
                }}
                className='universalButtonRed'
                style={{
                  width: "70%",
                  margin: 0,
                  marginBottom: 10,
                  height: 40,
                }}>
                Nei, ta med disse nå uten å publisere slik som dette
              </button>
              <button
                onClick={() => {
                  setOpenTMModal(false);
                }}
                className='universalButton'
                style={{
                  width: "70%",
                  marginTop: 10,
                  marginBottom: 0,
                }}>
                Nei, ta meg tilbake
              </button>
            </div>
          </div>
        </Modal>
      </>
    ) : sportsEventsAPI ? (
      <SportsAPIComponent
        currentBusinessID={currentBusinessID}
        businessLocations={businessLocations}
      />
    ) : xmlApi ? (
      <GetEventsFromXml
        currentBusinessID={currentBusinessID}
        businessLocations={businessLocations}
      />
    ) : universalAPI ? (
      <UniversalEventScraper
        currentBusinessID={currentBusinessID}
        businessLocations={businessLocations}
      />
    ) : (
      <>
        <h2>Hvilket API vil du benytte?</h2>
        <select
          onChange={(e) => {
            e.target.value === "sportsEvents"
              ? setSportsEventsAPI(true)
              : e.target.value === "universalAPI"
                ? setUniversalAPI(true)
                : e.target.value === "ticketmaster"
                  ? setNewTMEvents(true)
                  : e.target.value === "xmlEvents" && setXMLApi(true);
          }}
          className='selectInput'>
          <option value='' disabled selected>
            Velg API
          </option>
          <option value='ticketmaster'>Ticketmaster</option>
          <option value='sportsEvents'>SportsEvents</option>
          <option value='universalAPI'>Universal API</option>
          <option value='xmlEvents'>XML Events</option>
        </select>
      </>
    )
  ) : (
    <>
      <div>
        <h1>Arrangementer</h1>
        <button
          className='universalButton'
          onClick={() => {
            setNewEvent(true);
          }}>
          + Opprett arrangement
        </button>
        {userInformation?.admin && (
          <>
            <button
              className='universalButtonRed'
              style={{ marginLeft: "10px" }}
              onClick={() => {
                setAPIEvents(true);
              }}>
              Hent arrangementer fra et eksternt API
            </button>
            <button
              className='universalButtonRed'
              onClick={() => {
                onDeleteAllEvets();
              }}>
              + Slett alle arrangementer
            </button>
          </>
        )}
        <div>
          <div className='eventHeader'>Framtidige arrangementer</div>
          {eventList
            .sort((a, b) => a.data().endDate - b.data().endDate)
            .map((x, index) => {
              if (x.data().endDate * 1000 > new Date().getTime()) {
                return (
                  <div className='eventMain'>
                    <label style={{ fontWeight: "bold" }}>
                      {x.data().locationName}
                    </label>
                    <label>
                      Dato:{" "}
                      {new Date(x.data().eventDate * 1000).toLocaleDateString(
                        "nb-NO",
                        {
                          day: "2-digit", // Ensure the day is two digits
                          month: "2-digit", // Ensure the month is two digits
                          year: "numeric", // Full year
                        },
                      )}
                    </label>
                    <div>
                      {userInformation?.admin && (
                        <button onClick={() => onPromotePlussSeven(x)}>
                          Promoter pluss syv
                        </button>
                      )}
                      <label
                        style={{
                          color: x.data().active ? "#52c78c" : "#f9615b",
                        }}>
                        {x.data().active
                          ? "Promoteres fra " +
                            new Date(
                              x.data().startDate * 1000,
                            ).toLocaleDateString("nb-NO", {
                              day: "2-digit", // Ensure the day is two digits
                              month: "2-digit", // Ensure the month is two digits
                              year: "numeric", // Full year
                            })
                          : "Promoteres ikke på arrangementssiden i appen"}
                      </label>
                      <a
                        href={"/MyBusiness/events/" + x.id}
                        className='universalButtonRed'>
                        Rediger
                      </a>
                    </div>
                  </div>
                );
              }
            })}
        </div>

        <div style={{ marginTop: "50px" }}>
          <div className='eventHeader'>Eldre arrangementer</div>
          {eventList.map((x, index) => {
            if (x.data().endDate * 1000 < new Date().getTime()) {
              return (
                <div className='eventMain'>
                  <label style={{ fontWeight: "bold" }}>
                    {x.data().locationName}
                  </label>
                  <label>
                    Dato:{" "}
                    {new Date(x.data().eventDate * 1000).toLocaleDateString(
                      "nb-NO",
                      {
                        day: "2-digit", // Ensure the day is two digits
                        month: "2-digit", // Ensure the month is two digits
                        year: "numeric", // Full year
                      },
                    )}
                  </label>
                  <div>
                    <label
                      style={{
                        color: x.data().active ? "#52c78c" : "#f9615b",
                      }}>
                      {x.data().active ? "Aktiv" : "Ikke aktiv"}
                    </label>
                    <a
                      href={"/MyBusiness/events/" + x.id}
                      className='universalButton'>
                      Åpne
                    </a>
                  </div>
                </div>
              );
            }
          })}
        </div>
      </div>
    </>
  );
};

export default Events;
